import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTranslation } from 'react-i18next';

const { FiPlus, FiMinus } = FiIcons;

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation();

  const faqs = [
    {
      question: t('Chi si occupa della gestione degli ospiti?'),
      answer: t('Ci pensiamo noi completamente: dalle comunicazioni pre-arrivo all\'accoglienza, dal supporto durante il soggiorno alla gestione del check-out. Il nostro team è disponibile H24 per assistere gli ospiti in qualsiasi necessità.')
    },
    {
      question: t('Cosa devo fare io, da proprietario?'),
      answer: t('Praticamente nulla! Devi solo darci accesso all\'immobile. Ci occupiamo noi di tutto il resto: dalla promozione online alla gestione degli ospiti, dalle pulizie alla manutenzione ordinaria.')
    },
    {
      question: t('Quanto posso guadagnare con un affitto breve?'),
      answer: t('Con la nostra gestione professionale a Milano, puoi guadagnare fino al 30-50% in più rispetto all\'affitto tradizionale grazie a strategie di pricing dinamico.')
    },
    {
      question: t('Esiste un contratto vincolante?'),
      answer: t('No, non esistono vincoli a lungo termine. Il nostro contratto è flessibile, garantendoti la massima libertà nella gestione del tuo patrimonio.')
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="pt-16">
      <section className="bg-brand-blue py-20 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl md:text-5xl font-black mb-6 uppercase tracking-tight">
            {t('Domande Frequenti')}
          </motion.h1>
          <p className="text-xl text-brand-silver max-w-3xl mx-auto font-light">
            Tutto quello che devi sapere sulla gestione Premium di Castello SRL.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div key={index} className="bg-brand-blue/5 rounded-2xl overflow-hidden border border-brand-silver/20">
                <button 
                  onClick={() => toggleFAQ(index)} 
                  className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-brand-blue/10 transition-colors"
                >
                  <h3 className="text-lg font-bold text-brand-blue pr-4">{faq.question}</h3>
                  <SafeIcon icon={openIndex === index ? FiMinus : FiPlus} className="h-5 w-5 text-brand-gold flex-shrink-0" />
                </button>
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                      <div className="px-8 pb-6 text-brand-subtle leading-relaxed">
                        {faq.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-blue/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-brand-blue mb-6">Non hai trovato la risposta?</h2>
          <p className="text-xl text-brand-subtle mb-10">Il nostro team è sempre disponibile per una consulenza rapida.</p>
          <a 
            href="mailto:info@castellomanagement.it" 
            className="inline-block bg-brand-gold text-white px-10 py-4 rounded-xl font-bold hover:bg-brand-blue transition-all shadow-xl"
          >
            SCRIVICI DIRETTAMENTE
          </a>
        </div>
      </section>
    </div>
  );
};

export default FAQ;